<i18n>
{
    "et": {
        "Continue with {provider}": "Sisene {provider} kontoga",
        "{provider}": "{provider}"
    }
}
</i18n>

<template>
  <div
    class="social-auth d-flex justify-center"
    :class="{ 'flex-column': !row, colored: !transparent }"
  >
    <!-- <v-btn rounded
      v-for="provider in ['google', 'facebook']" -->
    <v-btn
      rounded
      v-for="provider in ['google', 'facebook']"
      :key="provider"
      v-bind="$attrs"
      :class="provider + '-btn ' + btnClass"
      :style="btnStyle"
      @click="onSocialAuthBtnClick(provider)"
    >
      <v-icon left>{{ "mdi-" + provider }}</v-icon>
      {{ $t(translation).replace("{provider}", provider) }}
    </v-btn>

    <slot name="after"></slot>
  </div>
</template>

<script>
import openPopupWindow from "@/_shared/lib/popup-window-opener";
import siteDomain from "@/_shared/lib/meta/site-domain";

export default {
  props: {
    btnClass: { type: String, default: "" },
    translation: { type: String, default: "Continue with {provider}" },
    btnStyle: { type: String, default: null },
    transparent: { type: Boolean, default: false },
    row: { type: Boolean, default: false },
    authenticatesClientOfEntity: { type: String, default: null },
    domain: { type: String, default: null }, // for widget that can be added on another site
  },
  data() {
    return {
      user: {},
      client: {},
    };
  },
  methods: {
    onSocialAuthBtnClick(provider) {
      // if (process.env.NODE_ENV === "development") {
      //   /**
      //    *  Messages between windows dont work on development because of different url(port).
      //    *  So we just imitate success.
      //    */
      //   this.onUserOrClientReceived({
      //     data: { id: 5, email: "k22rma@gmail.com", tel: null, name: "Kristjan Käärma" },
      //   });
      //   return;
      // }
      const baseUrl =  this.$store.state.baseUrl ? this.$store.state.baseUrl : siteDomain;
      let url = baseUrl + "social/login/" + provider;
      // let url = siteDomain + "social/login/" + provider;
        console.log(this.authenticatesClientOfEntity)
      if (this.authenticatesClientOfEntity) {
        url += "/" + this.authenticatesClientOfEntity;
      }
      console.log(url);
      openPopupWindow(url, "Login with " + provider, this.onUserOrClientReceived);
    },

    onUserOrClientReceived(event) {
      if (this.authenticatesClientOfEntity) {
        if (event.data.client) {
          this.client = event.data.client;
          this.$emit("auth", this.client);
        }
      } else {
        if (event.data.user) {
          this.user = event.data.user;
          this.$emit("auth", this.user);
        }
      }
    },
  },
};
</script>

<style lang="scss" >
.social-auth.colored {
  .twitter-btn {
    background: #28aae1 !important;
    color: #fff;
    &:hover {
      background: darken(#28aae1, 10%) !important;
    }
  }
  .facebook-btn {
    background: #3b579d !important;
    color: #fff;
    &:hover {
      background: darken(#3b579d, 5%) !important;
    }
  }
  .google-btn {
    background: #dd493c !important;
    color: #fff;
    &:hover {
      background: darken(#dd493c, 5%) !important;
    }
  }
  .bookus-btn {
    background: #9c27b0 !important;
    color: #fff;
    &:hover {
      background: darken(#9c27b0, 5%) !important;
    }
  }
}
</style>
